import { Injectable } from '@angular/core';
import { Exchange } from '../trade-system.model';

@Injectable({
  providedIn: 'root',
})
export class ExchangesNamingService {
  renameExchanges(exchanges: Exchange[]) {
    exchanges.forEach(exchange => this.rename(exchange))
    return exchanges
  }

  private rename(exchange: Exchange) {
    if (exchange.name.startsWith('Moex Currencies')) {
      exchange.name = exchange.name.replace('Moex Currencies', 'Валюта')
    }
    else if (exchange.name.startsWith('Moex Equties')) {
      exchange.name = exchange.name.replace('Moex Equties', 'Акции')
    }
    else if (exchange.name.startsWith('Moex Futures')) {
      exchange.name = exchange.name.replace('Moex Futures', 'Фьючерсы')
    }
  }
}
